// extracted by mini-css-extract-plugin
export default {"ingredientsSection":"Ingredients_ingredientsSection__rrH4h","ingredientsList":"Ingredients_ingredientsList__Jujcp","ingredientsItem":"Ingredients_ingredientsItem__8BYfg"};